import React, { Component } from "react";

class NotificationToast extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false, exiting: false };
    this.timer = null;
    this.exitTimer = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.message && this.props.message !== prevProps.message) {
      clearTimeout(this.timer);
      clearTimeout(this.exitTimer);
      this.setState({ visible: true, exiting: false });
      this.timer = setTimeout(() => {
        this.setState({ exiting: true });
        this.exitTimer = setTimeout(() => {
          this.setState({ visible: false, exiting: false });
          if (this.props.onDismiss) this.props.onDismiss();
        }, 400);
      }, this.props.duration || (this.props.type === "warning" ? 5000 : 3000));
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.exitTimer);
  }

  render() {
    if (!this.state.visible || !this.props.message) return null;

    const type = this.props.type || "success";
    const configs = {
      success: { bg: "#f0fdf4", border: "#bbf7d0", icon: "ni-check-circle-fill", iconColor: "#16a34a", titleColor: "#15803d" },
      error: { bg: "#fef2f2", border: "#fecaca", icon: "ni-cross-circle-fill", iconColor: "#dc2626", titleColor: "#b91c1c" },
      warning: { bg: "#fffbeb", border: "#fde68a", icon: "ni-alert-circle-fill", iconColor: "#d97706", titleColor: "#b45309" },
      info: { bg: "#eff6ff", border: "#bfdbfe", icon: "ni-info-fill", iconColor: "#2563eb", titleColor: "#1d4ed8" },
    };
    const c = configs[type] || configs.success;

    return (
      <div
        style={{
          position: "fixed",
          top: "24px",
          right: "24px",
          zIndex: 99999,
          minWidth: "340px",
          maxWidth: "440px",
          backgroundColor: c.bg,
          border: `1px solid ${c.border}`,
          borderRadius: "12px",
          padding: "16px 20px",
          boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          animation: this.state.exiting
            ? "toastSlideOut 0.4s ease forwards"
            : "toastSlideIn 0.4s cubic-bezier(0.16,1,0.3,1) forwards",
        }}
      >
        <style>{`
          @keyframes toastSlideIn {
            from { opacity: 0; transform: translateX(100%) scale(0.95); }
            to { opacity: 1; transform: translateX(0) scale(1); }
          }
          @keyframes toastSlideOut {
            from { opacity: 1; transform: translateX(0) scale(1); }
            to { opacity: 0; transform: translateX(100%) scale(0.95); }
          }
        `}</style>
        <div
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: c.iconColor + "14",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <em
            className={`icon ni ${c.icon}`}
            style={{ fontSize: "18px", color: c.iconColor }}
          ></em>
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: "700",
              fontSize: "14px",
              color: c.titleColor,
              marginBottom: "2px",
              lineHeight: 1.3,
            }}
          >
            {this.props.title || (type === "success" ? "Success" : type === "error" ? "Error" : "Info")}
          </div>
          <div
            style={{
              fontSize: "13px",
              color: "#475569",
              lineHeight: 1.5,
            }}
          >
            {this.props.message}
          </div>
        </div>
        <button
          onClick={() => {
            clearTimeout(this.timer);
            clearTimeout(this.exitTimer);
            this.setState({ exiting: true });
            setTimeout(() => {
              this.setState({ visible: false, exiting: false });
              if (this.props.onDismiss) this.props.onDismiss();
            }, 400);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            color: "#94a3b8",
            fontSize: "16px",
            lineHeight: 1,
            flexShrink: 0,
            marginTop: "2px",
          }}
        >
          <em className="icon ni ni-cross"></em>
        </button>
      </div>
    );
  }
}

export default NotificationToast;
